"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAccordionElement = exports.AccordionElement = exports.Collapsable = exports.Collapser = void 0;
var React = require("react");
var react_textarea_autosize_1 = require("react-textarea-autosize");
var typestyle_1 = require("typestyle");
var App_1 = require("../../App");
var generic_1 = require("../generic");
var Collapser = (function (_super) {
    __extends(Collapser, _super);
    function Collapser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Collapser.prototype.getContentIndicatorIcon = function () {
        return this.props.containsData ? (React.createElement(generic_1.Icon, { name: generic_1.Icons.circle, prefix: "fas", size: "xs" })) : (React.createElement(generic_1.Icon, { name: generic_1.Icons.circle, prefix: "far", size: "xs" }));
    };
    Collapser.prototype.getExpansionIndicatorIcon = function () {
        return this.props.isExpanded ? (React.createElement(generic_1.Icon, { name: generic_1.Icons.angle_down, fixedWidth: true })) : (React.createElement(generic_1.Icon, { name: generic_1.Icons.angle_right, fixedWidth: true }));
    };
    Collapser.prototype.getActionName = function () {
        if (this.props.isExpanded) {
            return gettext("Collapse");
        }
        else {
            return gettext("Expand");
        }
    };
    Collapser.prototype.render = function () {
        var props = this.props;
        var directionModifier = "Collapser--vertical";
        return (React.createElement("div", { className: (0, typestyle_1.classes)("Collapser", directionModifier), onClick: this.props.onClick, title: this.getActionName() + " " + this.props.caption },
            React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                React.createElement("div", null,
                    this.getExpansionIndicatorIcon(),
                    " ",
                    props.caption),
                this.getContentIndicatorIcon())));
    };
    return Collapser;
}(React.Component));
exports.Collapser = Collapser;
var Collapsable = (function (_super) {
    __extends(Collapsable, _super);
    function Collapsable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Collapsable.prototype.render = function () {
        return (React.createElement("div", { className: "Collapsable" }, this.props.children));
    };
    return Collapsable;
}(React.Component));
exports.Collapsable = Collapsable;
var AccordionElement = (function (_super) {
    __extends(AccordionElement, _super);
    function AccordionElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccordionElement.prototype.handleCollapserClicked = function (e) {
        var props = this.props;
        App_1.store.riskPage.accordion.setElementShown(props.id, !this.props.isOpen);
    };
    AccordionElement.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var isOpen = props.isOpen;
        var isOpenModifier = isOpen ? "AccordionElement--open" : "AccordionElement--closed";
        return (React.createElement("div", { className: (0, typestyle_1.classes)("AccordionElement", isOpenModifier) },
            React.createElement(Collapser, { id: props.id, caption: props.caption, containsData: props.containsData, isExpanded: isOpen, onClick: function (e) { return _this.handleCollapserClicked(e); } }),
            React.createElement("div", { className: "container" }, (isOpen ? React.createElement(Collapsable, { children: props.children }) : null))));
    };
    return AccordionElement;
}(React.Component));
exports.AccordionElement = AccordionElement;
var TextAccordionElement = (function (_super) {
    __extends(TextAccordionElement, _super);
    function TextAccordionElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { value: props.value };
        return _this;
    }
    TextAccordionElement.prototype.handleDataChanged = function (e) {
        App_1.store.riskPage.accordion.texts[this.props.id] = e.target.value;
        var didChange = e.target.value != this.state.value;
        if (didChange) {
            this.setState({ value: e.target.value });
        }
        switch (this.props.id) {
            case 'cause':
                changed = didChange;
                break;
            case 'risk':
                changed = didChange;
                $('#id_risk_description').val(e.target.value);
                break;
            case 'effect':
                changed = didChange;
                break;
            case 'notes':
                changed = didChange;
                $('#id_notes_description').val(e.target.value);
                break;
            default:
                break;
        }
    };
    TextAccordionElement.prototype.containsData = function () {
        return App_1.store.riskPage.accordion.texts[this.props.id] != '';
    };
    TextAccordionElement.prototype.render = function () {
        var props = this.props;
        var state = this.state;
        return (React.createElement(AccordionElement, { id: props.id, caption: props.caption, isOpen: props.isOpen, containsData: this.containsData() },
            React.createElement(react_textarea_autosize_1.default, { minRows: 4, maxRows: 20, className: "form-control TextareaAutosize--height_constrained", value: state.value, onChange: this.handleDataChanged.bind(this), id: "id_".concat(props.id) })));
    };
    return TextAccordionElement;
}(React.Component));
exports.TextAccordionElement = TextAccordionElement;
